<template>
  <v-layout row wrap style="position: relative">
    <v-flex xs12>
      <v-img :src="require('@/assets/images/privately-logo.png')" height="30px" contain style="margin-top: 38px" />
    </v-flex>
    <v-container>
      <v-layout align-center justify-center height="52px" style="margin-top: 32px">
        <v-flex shrink>
          <span
            style="
              font-family: Fredoka One;
              font-style: normal;
              font-weight: normal;
              font-size: 43px;
              line-height: 52px;
              display: flex;
              align-items: center;
              text-align: center;
              color: #18739d;
              flex: none;
              order: 3;
              flex-grow: 0;
              margin: 0px 0px;
            "
          >
            Age estimation with voice
          </span>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container>
      <v-layout align-center justify-center>
        <span
          v-if="!isRecording"
          style="
            font-family: Varela Round;
            font-style: normal;
            font-weight: normal;
            font-size: 18px;
            width: 480px;
            line-height: 22px;
            text-align: center;
          "
        >
          Please press the button below to start recording. You will be asked to read a sentence. For more information
          on how we process data, please refer to
          <a href="https://www.privately.eu/legal" target="_blank">our privacy policy </a>
        </span>

        <span
          v-else
          style="
            font-family: Varela Round;
            font-style: normal;
            font-weight: normal;
            font-size: 18px;
            width: 480px;
            line-height: 22px;
            text-align: center;
          "
        >
          Read the following sentence: <br />
          <br />
          <b>{{ displayedText }}</b>
        </span>
      </v-layout>
    </v-container>
    <v-flex
      height="126px"
      width="420px"
      style="margin-top: 32px; position: absolute; left: 0%; right: 0%; top: calc(90% + 0px)"
    >
      <v-layout row align-center justify-center style="margin-top: 24px">
        <v-card style="width: 480px; height: 150px" elevation="0">
          <v-progress-linear
            :indeterminate="isProcessing && !processingDone"
            style="margin-top: -5px"
            :value="progressValue"
          ></v-progress-linear>
          <v-card-title class="justify-center" v-if="isProcessing && !processingDone">
            <span
              style="
                font-family: Varela Round;
                font-style: normal;
                font-weight: normal;
                font-size: 18px;
                width: 480px;
                line-height: 22px;
                text-align: center;
              "
              >Processing, please wait ...</span
            >
          </v-card-title>
          <v-card-actions class="justify-center" style="margin-top: 30px">
            <v-btn
              @click="!isRecording ? startRecording() : stopRecording()"
              fab
              dark
              color="indigo"
              v-if="!isProcessing || processingDone"
            >
              <v-icon v-if="!isRecording" dark> mic </v-icon>

              <v-icon v-else dark> stop </v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-layout>
    </v-flex>

    <v-layout
      :key="componentKey"
      v-if="!isProcessing && processingDone"
      style="
        min-width: 320px;
        width: 80%;
        max-width: 480px;
        margin-top: 230px;
        margin: auto;
        position: absolute;
        left: 0%;
        right: 0%;
        top: calc(50% + 300px);
        padding: 20px 30px 30px;
        background: #6fdcff;
        align-self: center;
        border-radius: 20.125px;
      "
    >
      <span style="text-align: center">
        <h3>Estimation Results:</h3>
        <br />
        <ul style="list-style-type: square; text-align: left; display: table-cell">
          <li><b>Extracted text: </b>{{ extractedText }}</li>
          <!--<li><b>Extracted emotion: </b>{{ getEmotion(extractedEmotion) }}</li>-->
          <!--<li><b>Hate speech: </b>{{ (hateSpeechScore > 0.75 ? "hate" : "clean") + " (" + hateSpeechScore.toFixed(2) + ")" }}</li>-->
          <!--<li><b>Toxicity: </b>{{ (toxicityScore > 0.75 ? "toxic" : "clean") + " (" + toxicityScore.toFixed(2) + ")" }}</li>-->
          <!--<li><b>Profanity: </b>{{ profanityScore > 0.5 ? "profane" : "clean" }}</li>-->
          <li><b>Estimated age: </b>{{ getAgeThreeWays13(estimatedAge) }}</li>
          <li><b>Age confidence (fine-grained)> </b> {{ ageConfidence.toFixed(2) }}</li>
          <li><b>Estimated gender: </b>{{ estimatedGender }}</li>
          <li><b>Genuineness score: </b>{{ getGenuinessScore(genuinenessScore) }}</li>
        </ul>
      </span>
    </v-layout>
  </v-layout>
</template>


<script>
import axios from "axios";

axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
axios.defaults.withCredentials = false;

console.log("landed!");

function getUrlParam(parameter, defaultvalue) {
  var urlparameter = defaultvalue;
  if (window.location.href.indexOf(parameter) > -1) {
    urlparameter = getUrlVars()[parameter];
  }
  return urlparameter;
}

function getUrlVars() {
  var vars = {};
  var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
    vars[key] = value;
  });
  return vars;
}

export default {
  setup() {},
  methods: {
    forceRerender() {
      this.componentKey++;
    },
    fireProgressBar() {
      this.timer = setInterval(() => {
        this.progressValue += 1.3;
      }, 100);
      setTimeout(() => {
        if (this.isRecording) {
          this.stopRecording();
          clearInterval(this.timer);
          this.progressValue = 0;
        }
      }, 8000);
    },
    startRecording() {
      this.displayedText = this.sentences[Math.floor(Math.random() * 5)];
      this.audioChunks = [];
      this.progressValue = 0;
      var ref = this;
      this.processingDone = false;
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia(this.constraints)
          .then(function (stream) {
            ref.fireProgressBar();
            ref.audioRecorder = new MediaRecorder(stream);
            ref.audioRecorder.start();
            ref.isRecording = true;
            console.log(ref.audioRecorder.state);
            console.log("recorder started");

            ref.audioRecorder.ondataavailable = function (e) {
              console.log("data pushed");
              ref.audioChunks.push(e.data);
            };
          })
          .catch(function (err) {
            console.log("The following getUserMedia error occurred: " + err);
          });
      } else {
        console.log("getUserMedia not supported on your browser!");
      }
    },
    async stopRecording() {
      var ref = this;
      this.audioRecorder.stop();
      this.isRecording = false;
      this.isProcessing = true;
      clearInterval(this.timer);
      this.progressValue = 0;
      console.log("recording stopped");

      await new Promise((resolve) => setTimeout(resolve, 1000));

      var superBuffer = new Blob(this.audioChunks, { type: "video/webm" });

      var reader = new window.FileReader();
      reader.readAsDataURL(superBuffer);
      reader.onloadend = function () {
        var base64 = reader.result;
        base64 = base64.split(",")[1];
        // console.log(base64);

        const req = { voice_data: base64, use_spoof: true, spoken_text: ref.displayedText };
        const headers = { "Content-Type": "application/json; charset=utf-8" };
        var requestsUrl = "https://showroom.privately.swiss"; // if no dev requests URL specified, use relative URL (same host)
        /*if (typeof process.env.VUE_APP_REQUESTS_HOST !== 'undefined') {
            requestsUrl = 'https://showroom.privately.swiss'; // specified dev requests URL
        } else if (location.host.includes('localhost')) {
            requestsUrl = 'http://localhost:5001'; // default dev requests URL
        }*/

        console.log(requestsUrl + ":8081/showroom/voice-hate-speech");

        axios
          .post(requestsUrl + ":8081/showroom/voice-hate-speech", req, { headers })
          .then((response) => {
            if (response.data) {
              //console.log(response);
              ref.hateSpeechScore = response.data.hate;
              ref.toxicityScore = response.data.toxicity;
              ref.profanityScore = response.data.profanity;
              ref.extractedEmotion = response.data.emotion;
              ref.extractedText = response.data.text;
              ref.estimatedAge = response.data.age;
              ref.ageConfidence = response.data.age_proba < 0.5 ? response.data.age_proba * 2 : 1.0;
              ref.estimatedGender = response.data.gender;
              ref.genuinenessScore = response.data.genuineness;
              ref.forceRerender();
              ref.isProcessing = false;
              ref.processingDone = true;

              // iFrame CODE SNIPPET
              var pass_data = {
                age_identified: response.data.age,
                score: response.data.age_proba < 0.5 ? response.data.age_proba * 2 : 1.0,
                verified: "true",
              };
              parent.postMessage(JSON.stringify(pass_data), "*");

              let session_id = getUrlParam("api_key", null);
              let session_password = getUrlParam("api_secret", null);
              let transaction_id = getUrlParam("transaction_id", null);
              let reportingURL =
                "https://fwrxnwsu41.execute-api.eu-west-1.amazonaws.com/default/d-privately-audio-services";
              if (transaction_id != null) {
                var reportingRequestOptions = {
                  method: "POST",
                  headers: { "Content-Type": "application/json", "Access-Control-Allow-Origin": "*" }, //
                };

                reportingRequestOptions["body"] = JSON.stringify({
                  request_type: "complete_transaction",
                  transaction_id: transaction_id,
                  api_key: session_id,
                  api_secret: session_password,
                  browser_response_data: {
                    age: ref.estimatedAge,
                    age_confidence: ref.ageConfidence,
                    genuineness: ref.genuinenessScore,
                  },
                });
                fetch(reportingURL, reportingRequestOptions).then(async (response) => {
                  console.log("Response logged");
                });
              }
            }
          })
          .catch((error) => {
            ref.processingDone = true;
            ref.isProcessing = false;
            console.error("There was an error!", error);
          });
      };
    },
    getAge(ageGroup) {
      switch (ageGroup) {
        case "childhood":
          return "0 - 7";
        case "puberty":
          return "8 - 12";
        case "adolescence":
          return "13 - 17";
        case "early_adulthood":
          return "18 - 24";
        case "adulthood":
          return "25 - 34";
        case "middle_age":
          return "35 - 50";
        case "seniority":
          return "51+";
      }
    },
    getAgeThreeWays(ageGroup) {
      switch (ageGroup) {
        case "childhood":
        case "puberty":
        case "adolescence":
          return "minor (<18)";
        case "early_adulthood":
          return "adult (18-24)";
        case "adulthood":
        case "middle_age":
        case "seniority":
          return "adult (25+)";
      }
    },
    getAgeThreeWays13(ageGroup) {
      switch (ageGroup) {
        case "childhood":
        case "puberty":
          return "0-13 (young child)";
        case "adolescence":
          return "13-17 (teenager)";
        case "early_adulthood":
        case "adulthood":
        case "middle_age":
        case "seniority":
          return "18+ (adult)";
      }
    },
    getEmotion(emotion) {
      switch (emotion) {
        case "neu":
          return "neutral";
        case "ang":
          return "anger";
        case "sad":
          return "sad";
        case "hap":
          return "happy";
        default:
          return emotion;
      }
    },
    getGenuinessScore(score) {
      return Math.max(0.0, Math.min(1.0, score));
    },
  },
  data() {
    return {
      sentences: [
        "No, I learned by myself. I have a good cook book that I read when I have time.",
        "I think I can take the subway to the airport. Do you know where the subway is?",
        "She spends a pretty good chunk of time just sitting there and looking out the window.",
        "No, I don't think so. I would need to stay there for a year, and I don't think I can take that much time off work.",
        "Well, I still haven't finished my Christmas shopping. Do you want to go shopping with me this weekend?",
      ],
      progressValue: 0,
      isRecording: false,
      audioStopped: false,
      audioRecorder: null,
      extractedText: "",
      extractedEmotion: "",
      hateSpeechScore: 0,
      processingDone: false,
      toxicityScore: 0,
      profanityScore: 0,
      estimatedAge: "",
      estimatedGender: "",
      genuinenessScore: 0.0,
      componentKey: 0,
      isProcessing: false,
      audioChunks: [],
      displayedText: "Recording...",
      constraints: {
        audio: {
          sampleRate: 16000,
          channelCount: 1,
        },
        headers: { "Content-Type": "application/json; charset=utf-8" },
      },
    };
  },
};
</script>



